export default "__VITE_ASSET__01170865__"